<div class="h-full flex flex-col overflow-hidden bg-[var(--main-light)]">
  <ng-container *ngIf="!isLoading">
    <mat-card class="p-4 rounded-2xl bg-[var(--main)] z-10">
      <div class="flex items-center gap-2">
        <h5 class="flex-1 font-semibold">
          {{ groupe.groupe_ID === 0 ? 'Création d\'un groupe' :
          groupe.groupe_Libelle || 'Modification d\'un groupe' }}
        </h5>
        <div class="flex items-center gap-2">
          <button
            class="btn-fab txt-primary"
            (click)="postGroupe()"
            matTooltip="Enregistrer"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            *ngIf="groupe.groupe_ID !== 0"
            class="btn-fab txt-danger"
            (click)="deleteGroupe()"
            matTooltip="Supprimer"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button class="btn-fab" (click)="close()" matTooltip="Fermer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>

    <div class="overflow-auto flex-1" style="max-height: calc(100dvh - 200px)">
      <app-informations [groupe]="groupe"></app-informations>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="flex-1 flex items-center justify-center p-4">
      <mat-spinner diameter="50"></mat-spinner> 
    </div>
  </ng-container>
</div>
